exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-phone-detail__phone-container{margin-bottom:24px}.account-phone-detail__phone-label{color:#c2c2c2}.account-phone-detail__phone-value{padding:8px 0 12px;border-radius:0;border-bottom:1px solid #bdbdbd;color:#adadad}.account-phone-detail__message{padding:12px 20px;border-radius:4px;background-color:#e8e8e8;color:#404041;font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/Account/Phone/AccountPhoneDetail/AccountPhoneDetail.scss
// module id = 875
// module chunks = 1